import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {BsModalRef, BsModalService, ModalModule} from 'ngx-bootstrap/modal';
import {EmailService} from '../../services/api/administration/email.service';
import {Backend} from '@generated-backend-types';
import {Observable, take} from 'rxjs';
import Email = Backend.App.Resources.Dashboard.Administration.Email;
import EmailPreviewData = Backend.App.Data.Dashboard.Administration.EmailPreviewData;
import {FormGroup} from '@angular/forms';
import {FormErrorService} from '../../services/form-error.service';

@Component({
  selector: 'app-email-preview',
  templateUrl: './email-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [BsModalService],
  standalone: true,
  imports: [ModalModule]
})
export class EmailPreviewComponent implements OnInit {
  @Input({required: true}) public email!: Email;
  @Input({required: true}) public previewData$!: Observable<EmailPreviewData>;
  @Input() public form?: FormGroup;

  @ViewChild('emailPreviewModal') protected emailPreviewModalTemplateRef?: TemplateRef<string>;
  protected previewHtmlModalRef?: BsModalRef;
  protected previewHtml: SafeHtml = '';

  public constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly modalService: BsModalService,
    private readonly sanitizer: DomSanitizer,
    private readonly emailService: EmailService,
    private readonly formErrorService: FormErrorService,
  ) {}

  public ngOnInit() {
    this.previewData$.subscribe(emailPreviewData => {
      this.emailService.preview(this.email.id, emailPreviewData)
        .subscribe({
          next: res => {
            this.previewHtml = this.sanitizer.bypassSecurityTrustHtml(res);
            this.previewHtmlModalRef = this.modalService.show(this.emailPreviewModalTemplateRef!, {class: 'email-preview-modal'});
            this.cdr.markForCheck();

            this.previewHtmlModalRef.onHide?.pipe(take(1)).subscribe(() => {
              this.previewHtml = '';
              this.cdr.markForCheck();
            });
          },
          error: err => {
            if (this.form) {
              this.formErrorService.mapErrorToForm(this.form, err);
              this.cdr.markForCheck();
            }
          }
        });
    })
  }
}
